import AddressSuggestionItem from 'components/AddressModal/components/AddressSuggestionItem/styled';

export default AddressSuggestionItem;
